//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'SubscribeBenefits2026',
  data() {
    return {
      faBadgeCheck,
    };
  },
};
